import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginComponent } from '@shared/core/components/login/login.component';
import { PW_ENVIRONMENT } from '@shared/core/constants/injectors.constant';
import { IEnvironment } from '@shared/core/interfaces/environment.interface';
import { AuthService } from '@utils/src/utils/services/auth/auth.service';
import { HealthCheckService } from '@utils/src/utils/services/health-check/health-check.service';
import { ToastrService } from 'ngx-toastr';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { Title } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';

@Component({
  templateUrl: './carrier-login.component.html',
  styleUrls: ['carrier-login.component.scss'],
})
export class CarrierLoginComponent extends LoginComponent implements OnInit {
  showLoginAlert = false;
  needsCarrierUser = true;

  constructor(
    @Optional() public health: HealthCheckService,
    protected _authService: AuthService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _toastr: ToastrService,
    public _dialog: MatDialog,
    public _translate: TranslateService,
    @Optional() public _angularFireAnalytics: AngularFireAnalytics,
    @Optional() @Inject(PW_ENVIRONMENT) public environment: IEnvironment,
    private titleService: Title,
    ) {
    super(health, _authService, _router, _route, _toastr, _dialog, _translate, _angularFireAnalytics, environment);
    this.titleService.setTitle('Pickwings Carrier Panel: Login into the transport partner portal');
  }

  ngOnInit() {
    this._authService.isShowingAlert$.subscribe((data) => {
      this.showLoginAlert = data;
    });
    this._route.queryParams.subscribe(async params => {
      try {
        if (!!params.token) {
          const result = await lastValueFrom(this._authService.loginWithToken(params.token))
          if (result) {
            this._router.navigateByUrl(this._afterLoginPath, { replaceUrl: true });
          }
        }
      } catch (error) {
        console.error(error);
      }
    })
  }
}
